import { render, staticRenderFns } from "./Gira.vue?vue&type=template&id=1bdc0dd9&style=padding-top%3A%200px%3B&v-if=items.length%20%3E%200"
import script from "./Gira.vue?vue&type=script&lang=js"
export * from "./Gira.vue?vue&type=script&lang=js"
import style0 from "./Gira.vue?vue&type=style&index=0&id=1bdc0dd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports